import { render, staticRenderFns } from "./RecentImports.vue?vue&type=template&id=7c1ca9a4&"
import script from "./RecentImports.vue?vue&type=script&lang=js&"
export * from "./RecentImports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c1ca9a4')) {
      api.createRecord('7c1ca9a4', component.options)
    } else {
      api.reload('7c1ca9a4', component.options)
    }
    module.hot.accept("./RecentImports.vue?vue&type=template&id=7c1ca9a4&", function () {
      api.rerender('7c1ca9a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/Audience/Import/Pages/RecentImports.vue"
export default component.exports